import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import PlaceOrder from "../../../../components/Orders/Items/PlaceOrder";

const ItemAddOrder = (props) => {
  const storeName = localStorage.getItem("store_name")

  useEffect(() => {
    loadAllStores();
    // loadItems();
  }, []);

 
  const [allStores, setAllStores] = useState([]);

  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
     
      const result2 = response.data.filter((store) =>   store.type === "Main Store" && store.name !== storeName)
      setAllStores(result2);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadItems = async (data) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
    const response = await postSubmitForm(url, data);
    if (response && response.status === 1) {
      const selectOptions = response.data.filter((d)=>d.is_active).map(item => ({
        // ...item,
        // item_details:{
          _id:item.item_id,
          name:item.name,
          unit_levels:item.unit_levels,
          available:item.available,
          store_available:item.store_available,
          threshold:item.threshold,
          unit_for_threshold:item.unit_for_threshold,
          category:item.category,
          sub_category:item.sub_category,
          max_order_limit:item.max_order_limit,
          unit_for_max_order:item.unit_for_max_order,
          is_premium_item:item.is_premium_item,
        // },
        label: item.name,
        value: item.item_id
      }));
      preloader(false);
      setAllItems(selectOptions);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };


  function loaditems (data){
    loadItems({ store_id: data._id })
  }

 
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Orders")}
            alternateTitle={props.t("Add New Order")}
            breadcrumbItem1={props.t("New Order")}
            breadcrumbItem2={props.t("Add New Order")}
          />
         <PlaceOrder 
        allStores={allStores}
        allItems={allItems}
        onStoreSelect={loaditems}
        />

        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemAddOrder))
);

